const onThreeJsError = (error) => {
  // Render svg animation if something goes wrong
  const heroModule = document.querySelector('.hero-module__threejs');
  const heroModuleBackground = document.querySelector('.hero-module__background');

  if (heroModule) {
    heroModule.classList.add('is-hidden');
  }

  if (heroModuleBackground) {
    heroModuleBackground.classList.add('is-visible');
  }

  console.error(error);
};

const getThreeJsPath = () => {
  if (isFractal()) {
    return '../../images/three';
  }

  return '/wp-content/themes/cosylab/public/images/three';
};

const loadAnimation = () => {
  const loader = new THREE.GLTFLoader();

  loader.load(
    `${getThreeJsPath()}/models/Cosylab_cloth.gltf`,
    (gltf) => initAnimation(gltf),
    (xhr) => console.warn(`${(xhr.loaded / xhr.total) * 100}% loaded`),
    (error) => onThreeJsError(error),
  );
};

const initAnimation = ({ animations, ...gltf }) => {
  const heroModule = document.querySelector('.hero-module__threejs');
  const renderer = new THREE.WebGLRenderer({ antialias: true });
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(35, heroModule.clientWidth / heroModule.clientHeight, 1, 1000);
  const mixer = new THREE.AnimationMixer(scene);
  const clock = new THREE.Clock();

  // Add ambient light
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.3);
  scene.add(ambientLight);

  // Update existing directional light settings
  const light1 = new THREE.DirectionalLight(0xffffff, 1);
  light1.intensity = 2.5;
  light1.position.set(-2.5, 2.5, 10.5);
  light1.color.setHex(0xffffff);
  scene.add(light1);

  const light2 = new THREE.DirectionalLight(0xffffff, 1.5);
  light2.position.set(2.5, 2.5, -10.5);
  scene.add(light2);

  const light3 = new THREE.DirectionalLight(0xffffff, 1.5);
  light3.position.set(2.5, 2.5, 10.5);
  scene.add(light3);

  // Scene
  scene.add(gltf.scene);
  scene.background = new THREE.Color(0xffffff);

  // Animation
  (animations || []).forEach((clip) => mixer.clipAction(clip).play());

  const calculateFOV = () => {
    camera.position.set(0, 5, 16);
    camera.lookAt(scene.position);

    // The smaller FOV, the bigger the object will look
    // The bigger Y position, the more down it will be pushed
    switch (true) {
      case window.innerWidth < 768:
        camera.fov = 15;
        camera.position.y = 6;
        break;
      case window.innerWidth < 992:
        camera.fov = 30;
        camera.position.y = 5;
        break;
      case window.innerWidth < 1200:
        camera.fov = 30;
        camera.position.y = 4;
        break;
      case window.innerWidth < 1400:
        camera.fov = 35;
        break;
      default:
        camera.fov = 27;
        camera.position.y = 5;
    }
  };

  const render = () => renderer.render(scene, camera);

  // Runs every frame
  const animate = () => {
    requestAnimationFrame(animate);

    if (mixer) {
      mixer.update(clock.getDelta());
    }

    render();
  };

  const onWindowResize = () => {
    const containerWidth = heroModule.clientWidth;
    const containerHeight = heroModule.clientHeight;
    camera.aspect = containerWidth / containerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(containerWidth, containerHeight);
    calculateFOV();
    render();
  };

  renderer.setPixelRatio(window.devicePixelRatio);
  heroModule.appendChild(renderer.domElement);
  window.addEventListener('resize', onWindowResize);
  animate();

  // We have to call this twice to make sure that the animation is rendered correctly
  onWindowResize();
  setTimeout(() => onWindowResize(), 10);
  heroModule.classList.remove('is-hidden');

  // debug:
  // const controls = new THREE.OrbitControls(camera, renderer.domElement);
};

document.addEventListener('DOMContentLoaded', async () => {
  const heroModule = document.querySelector('.hero-module__threejs');

  if (heroModule) {
    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.type = 'text/javascript';
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load script'));
        document.getElementsByTagName('head')[0].appendChild(script);
      });

    try {
      /*
      Scripts are from:
      - https://unpkg.com/three@0.112.0/build/three.js
      - https://unpkg.com/three@0.112.0/examples/js/loaders/GLTFLoader.js
      - https://unpkg.com/three@0.112.0/examples/js/controls/OrbitControls.js
       */

      await loadScript(`${getThreeJsPath()}/three.js`);
      await loadScript(`${getThreeJsPath()}/GLTFLoader.js`);

      // debug:
      // await loadScript(`${getThreeJsPath()}/OrbitControls.js`);
      loadAnimation();
    } catch (error) {
      onThreeJsError(error);
    }
  } else {
    onThreeJsError('Three.js disabled');
  }
});
